import ComparePlansSheet from "../../components/ComparePlansSheet/ComparePlansSheet"
import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"
import UltimateBackground from "../../components/UltimateBackground/UltimateBackground"
import UltimateSubfeaturesPopups from "../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups"
import { useAppState } from "../../context/appStateContext"
import { PurchasProvider, usePurchase } from "../../context/purchaseContext"
import {
  UltimateAlertsProvider,
  useUltimateAlerts,
} from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"
import images from "../../utils/images"
import AlternativeBottomPaywall from "../AlternativeBottomPaywall/AlternativeBottomPaywall"
import TogglablePlanPaywall from "../TogglablePlanPaywall/TogglablePlanPaywall"
import styles from "./ConditionalUltimatePaywall.module.scss"
import useQueryParams from "../../hooks/useQueryParams"
import { usePostPurchase } from "../../context/postPurchaseContext"
import PostPurchasePaywalls from "../PostPurchasePaywalls/PostPurchasePaywalls"
import { useEffect } from "react"

const ConditionalUltimatePaywall = () => {
  const { state, actions } = useAppState()

  useEffect(() => {
    const color = getComputedStyle(document.documentElement)
      .getPropertyValue("--background")
      .trim()

    actions.setFooterInsetColor(color)
    actions.setHeaderInsetColor(color)
  }, [])

  if (!state.fullyLoaded) {
    return <div>Loading</div>
  }

  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <PaywallContent />
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

const PaywallContent = () => {
  const { state } = useAppState()

  const ultimatePlacement = state.productData?.isUltimatePlacement == true

  const ultimateVisible =
    state.productData?.ultimatePaywallGlobalApplies == true

  const postState = usePostPurchase().state

  if (!ultimateVisible && !ultimatePlacement) {
    return (
      <FullScreenPage>
        <AlternativeBottomPaywall />
        <PostPurchasePaywalls />
      </FullScreenPage>
    )
  }

  return (
    <FullScreenPage>
      <TogglablePlanPaywall
        Header={HeaderComponent}
        isPushedOut={postState.visibleFlowType != null}
      />
      <ComparePlansSheet />
      <UltimateSubfeaturesPopups />
      <UltimateBackground />
      <PostPurchasePaywalls />
    </FullScreenPage>
  )
}

const HeaderComponent = () => {
  const alerts = useUltimateAlerts()
  const { state } = usePurchase()
  const productData = useAppState().state.productData
  const strings = useStrings()
  const queryParams = useQueryParams()

  let ultimateOnly = productData?.isUltimatePlacement ?? false

  ultimateOnly =
    ultimateOnly ||
    (queryParams.ultimateOnly &&
      productData?.ultimatePaywallGlobalApplies == true)

  const showComparePlans = queryParams.ultimateOnly

  const title = state.ultimateSelected
    ? strings.comparePlans.unlockUltimate
    : strings.comparePlans.unlockPremium
  const imageClass = state.ultimateSelected
    ? images.ultimate.icon.class
    : images.yellowProLogo.class

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <img className={`${imageClass} ${styles.logo}`} />
      </div>
      <label className={styles.title}>{title}</label>
      {!ultimateOnly && <PlanSelection />}
      {showComparePlans && (
        <button
          className={styles.comparePlans}
          onClick={() => {
            alerts.actions.setShowComparePlansSheet(true)
          }}
        >
          {strings.comparePlans.title}
        </button>
      )}
    </div>
  )
}

const PlanSelection = () => {
  const { state, actions } = usePurchase()

  const { ultimateSelected } = state
  const strings = useStrings()

  return (
    <div className={styles.planSelectionContainer}>
      <label className={styles.subtitle}>{strings.comparePlans.choose}</label>
      <div className={styles.segmentedControl}>
        <Segment
          title={"Premium"}
          selected={!ultimateSelected}
          onClick={() => {
            actions.setUltimateSelected(false)
          }}
        />
        <Segment
          title={"Ultimate"}
          selected={ultimateSelected}
          onClick={() => {
            actions.setUltimateSelected(true)
          }}
        />
      </div>
    </div>
  )
}

const Segment = ({ title, selected, onClick }) => {
  return (
    <button
      className={`${styles.segment} ${selected ? styles.selected : ""}`}
      onClick={onClick}
    >
      {title}
    </button>
  )
}

export default ConditionalUltimatePaywall
